import { type ActivityTopicFilter } from '@apps/web/swr_data_fetching/data_fetching_hooks';

// Canonical UI labels for the activity topic taxonomy (derived server-side
// in `_activity_event_search.py`). Shared by the activity feed Filters menu
// and the voice-calls Topic filter so the two surfaces cannot drift when a
// topic is renamed or added. Voice calls omit `messages`, which only maps
// to SMS escalation events and can never match a call.
export const ACTIVITY_TOPIC_FILTER_OPTIONS: ReadonlyArray<{
    readonly value: ActivityTopicFilter;
    readonly label: string;
}> = [
    { value: 'open_shifts', label: 'Open shifts' },
    { value: 'clock_in_out', label: 'Clock issues' },
    { value: 'messages', label: 'Message escalations' },
    { value: 'care_or_client', label: 'Care or client' },
    { value: 'schedule_or_availability', label: 'Scheduling' },
    { value: 'human_request', label: 'Human request' },
    { value: 'wrong_contact_or_noise', label: 'Wrong contact/noise' },
    { value: 'other', label: 'Other' },
];
